import { render, staticRenderFns } from "./OpportunityOutputCard.vue?vue&type=template&id=3191d960&scoped=true"
import script from "./OpportunityOutputCard.vue?vue&type=script&lang=js"
export * from "./OpportunityOutputCard.vue?vue&type=script&lang=js"
import style0 from "./OpportunityOutputCard.vue?vue&type=style&index=0&id=3191d960&prod&scoped=true&lang=css"
import style1 from "./OpportunityOutputCard.vue?vue&type=style&index=1&id=3191d960&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3191d960",
  null
  
)

export default component.exports